/**
 * Builds the one synchronous Puck write used by Custom Width's blur commit.
 * Keeping this decision outside the widget lets the installed-Puck contract exercise the same
 * stale-sibling protection as production rather than a hand-written approximation.
 */
function buildCustomImageWidthStoreWrite({ selectedItem, selector, nextValue }) {
  if (!selectedItem || !selector) return { kind: 'fallback' };

  const storedLayout = selectedItem.props.layout;
  const layout =
    typeof storedLayout === 'object' && storedLayout !== null && !Array.isArray(storedLayout) ? storedLayout : {};
  if (Object.prototype.hasOwnProperty.call(layout, 'customWidth') && layout.customWidth === nextValue) {
    return { kind: 'noop' };
  }

  return {
    kind: 'dispatch',
    action: {
      type: 'replace',
      destinationIndex: selector.index,
      destinationZone: selector.zone,
      data: {
        ...selectedItem,
        props: { ...selectedItem.props, layout: { ...layout, customWidth: nextValue } },
      },
    },
  };
}

module.exports = { buildCustomImageWidthStoreWrite };
